import api from "app/api";

export interface RebookFeeReportItem {
  booking_id: number;
  rebooked_at: string;
  original_program_id: number | null;
  original_boat_id: number | null;
  original_start_time: string | null;
  original_program_name: string | null;
  number_of_guests: number;
  rebook_price: number;
  currency: "HUF" | "EUR";
  booking_name: string | null;
  partner_id: number | null;
  partner_name: string | null;
  reason: string | null;
  coordinator_id: number | null;
  coordinator_name: string | null;
}

export interface RebookFeeReportParams {
  from: string;
  to: string;
  currency?: "HUF" | "EUR";
  program_ids?: number[];
  boat_ids?: number[];
}

export interface RebookFeeReportResponse {
  items: RebookFeeReportItem[];
  currency: "HUF" | "EUR";
  total: number;
}

export async function getRebookFeeReport(params: RebookFeeReportParams) {
  return api.get<RebookFeeReportResponse>("reports/rebook-fees", {
    params,
  });
}
